var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-left mobileFullWidthWithMargin sidebar"},[_c('feature-item'),_c('best-seller-list',{attrs:{"placement":"sidebar"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }